import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zoom-in",
  "use": "icon-zoom-in-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-zoom-in\" id=\"icon-zoom-in\"><circle cx=\"11\" cy=\"11\" r=\"8\" /><line x1=\"21\" y1=\"21\" x2=\"16.65\" y2=\"16.65\" /><line x1=\"11\" y1=\"8\" x2=\"11\" y2=\"14\" /><line x1=\"8\" y1=\"11\" x2=\"14\" y2=\"11\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol